import React, { useState, useEffect } from 'react'
import {
  Container,
  TitleStyle2,
  Wrap,
  WrapInput
} from 'components/SharedComponents/styles';
import { overrideStrings } from 'contexts/SharedContext'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale'
import DateFnsUtils from '@date-io/date-fns';
import { SUCCESSMESSAGE, ERRORMESSAGE, WARNINGMESSAGE } from 'utils/types-messages';
import { api } from 'services/axios'
import { GetSessionUser, getMonthYear } from 'services/helpers'
import { useSnackbar } from 'notistack';
import { LabelInput, multSelect } from 'components/Input';
import MultiSelect from "react-multi-select-component";
import MessageAlert from 'components/MessageAlert'
import { Button } from "../../components/Button";
import { MySelect } from "../../components/InputSelect";
import { WrapInputDate } from "./styles"
import { Modal, CircularProgress } from "@material-ui/core";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { SearchBox, ItemsSearch, IconTxt } from "../../components/Search";
import { ErrorBox, ErrorBoxTitle, ErrorTable } from './styles';

export default function RelatorioAFD() {
  const { enqueueSnackbar } = useSnackbar();
  const { perfil } = GetSessionUser();

  const [afd, setAfd] = useState({ dataInicial: "", dataFinal: "", teamId: [], personId: [] });

  const [team, setTeam] = useState([]);
  const [teamSelected, setTeamSelected] = useState([]);

  const [person, setPerson] = useState([]);
  const [personSelected, setPersonSelected] = useState([]);

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateFim, setSelectedDateFim] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [loadDialog, setLoadDialog] = useState(false);

  const [monthYear] = useState(getMonthYear());
  const [selectedMesAno, setSelectedMesAno] = useState([]);

  // Inconsistências retornadas pelo backend (status desconhecido, mais de
  // um intervalo no mesmo dia) — funcionário + dia + motivo de cada uma,
  // para o RH corrigir tudo de uma vez em vez de tentativa/erro.
  const [errosAfd, setErrosAfd] = useState([]);

  //Combo Equipe
  const getTeam = async () => {
    try {
      const { data } = await api.get('/team?companyId=' + perfil.companyId)
      if (data.success) {
        const { result } = data
        setTeam(result.map((item) => ({ label: item.name, value: item.id })));
      } else {
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE)
      }
    } catch (err) {
      enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE)
    }
  }

  //Combo Colaboradores — quando teamIds vem preenchido, o backend já
  // retorna só quem está vinculado a uma dessas equipes (?teamId=1,2,3).
  const getPerson = async (teamIds) => {
    try {
      let url = '/person?companyId=' + perfil.companyId + '&status=1';
      if (teamIds && teamIds.length > 0) {
        url += '&teamId=' + teamIds.join(',');
      }
      const { data } = await api.get(url)
      if (data.success) {
        const { result } = data
        setPerson(result.map((item) => ({ label: item.name, value: item.id })));
      } else {
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE)
      }
    } catch (err) {
      enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE)
    }
  }

  useEffect(() => {
    getTeam();
    getPerson([]);
    setSelectedMesAno({ value: monthYear[monthYear[0].ind].id, label: monthYear[monthYear[0].ind].monthYear });
    handleDateChange(monthYear[monthYear[0].ind].dtInicial);
    handleDateChangeFim(monthYear[monthYear[0].ind].dtFinal);
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setErrosAfd([]);
    if (date === null) {
      setAfd(prev => ({ ...prev, dataInicial: "" }));
      setButtonDisable(true);
    } else {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, '0');
      const mes = String(newDate.getMonth() + 1).padStart(2, '0');
      const ano = newDate.getFullYear();
      setAfd(prev => ({ ...prev, dataInicial: `${day}/${mes}/${ano}` }));
      setButtonDisable(false);
    }
  }

  const handleDateChangeFim = (date) => {
    setSelectedDateFim(date);
    setErrosAfd([]);
    if (date === null) {
      setAfd(prev => ({ ...prev, dataFinal: "" }));
      setButtonDisable(true);
    } else {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, '0');
      const mes = String(newDate.getMonth() + 1).padStart(2, '0');
      const ano = newDate.getFullYear();
      setAfd(prev => ({ ...prev, dataFinal: `${day}/${mes}/${ano}` }));
      setButtonDisable(false);
    }
  }

  const handleMesAno = (item) => {
    setSelectedMesAno(item);
    if (item === null) {
      handleDateChange(null);
      handleDateChangeFim(null);
    } else {
      handleDateChange(monthYear[item.value].dtInicial);
      handleDateChangeFim(monthYear[item.value].dtFinal);
    }
  }

  // Ao trocar a equipe, o combo de colaboradores é recarregado só com quem
  // pertence às equipes selecionadas — e a seleção de colaboradores é
  // limpa, já que as opções válidas mudaram (mesmo padrão de encadeamento
  // usado em RelatorioHoraCliente ao trocar cliente/contrato/serviço).
  const handleTeam = (items) => {
    setTeamSelected(items);
    const teamIds = items.map(item => item.value);
    setAfd(prev => ({ ...prev, teamId: teamIds, personId: [] }));
    setPersonSelected([]);
    getPerson(teamIds);
  }

  const handlePerson = (items) => {
    setPersonSelected(items);
    setAfd(prev => ({ ...prev, personId: items.map(item => item.value) }));
  }

  // Baixa o arquivo automaticamente (em vez de abrir em nova aba/janela).
  // Usa blob + link temporário porque front e back rodam em origens
  // diferentes — um <a download> apontando direto pra URL do backend não
  // força o download de forma confiável em requisição cross-origin.
  async function baixarArquivo(path) {
    const response = await api.get(path, { responseType: 'blob' });
    const filename = path.split('/').pop();
    const blob = new Blob([response.data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  async function gerarAfd() {
    if (!afd.dataInicial || !afd.dataFinal) {
      enqueueSnackbar(<MessageAlert message={'Informe a data inicial e a data final do período!'} />, WARNINGMESSAGE);
      return;
    }

    setButtonDisable(true);
    setLoadDialog(true);
    setErrosAfd([]);

    try {
      const { data } = await api.put('/afd/gerar', afd);

      if (data.success) {
        await baixarArquivo(data.path);
        enqueueSnackbar('Arquivo AFD gerado com sucesso!', SUCCESSMESSAGE);
      } else if (data.errors && data.errors.length > 0) {
        setErrosAfd(data.errors);
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE);
      } else {
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE);
      }
    } catch (err) {
      enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE);
    }

    setButtonDisable(false);
    setLoadDialog(false);
  }

  function limparFiltros() {
    setTeamSelected([]);
    setPersonSelected([]);
    setErrosAfd([]);
    getPerson([]);
    setSelectedMesAno({ value: monthYear[monthYear[0].ind].id, label: monthYear[monthYear[0].ind].monthYear });
    handleDateChange(monthYear[monthYear[0].ind].dtInicial);
    handleDateChangeFim(monthYear[monthYear[0].ind].dtFinal);
    setAfd(prev => ({ ...prev, teamId: [], personId: [] }));
  }

  const modalLoad = (
    <div className={'disabeFocus alert-modal'}>
      <WrapInput className="alertText" style={{ alignItems: 'center' }}>
        <CircularProgress style={{ color: '#043D5D' }} /> <h3>Gerando o arquivo AFD, Aguarde!</h3>
      </WrapInput>
    </div>
  );

  return (
    <Container>
      <SearchBox>
        <TitleStyle2>Relatório AFD (flash)</TitleStyle2>
        <form>
          <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
            <Wrap style={{ position: 'relative' }}>
              <WrapInputDate>
                <KeyboardDatePicker
                  helperText={''}
                  minDateMessage="Não é possível buscar por datas futuras."
                  margin="normal"
                  clearLabel="Limpar"
                  cancelLabel="Cancelar"
                  clearable
                  id="dateInitialAfd"
                  label="Data Início"
                  format="dd/MM/yyyy"
                  onChange={handleDateChange}
                  value={selectedDate}
                  minDate={new Date(new Date("01-01-2018"))}
                  maxDate={new Date(new Date())}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                />
              </WrapInputDate>
              <WrapInputDate>
                <KeyboardDatePicker
                  helperText={''}
                  minDateMessage="Não é possível buscar por datas futuras."
                  margin="normal"
                  clearLabel="Limpar"
                  cancelLabel="Cancelar"
                  clearable
                  id="dateFinalAfd"
                  label="Data Fim"
                  format="dd/MM/yyyy"
                  onChange={handleDateChangeFim}
                  value={selectedDateFim}
                  minDate={new Date(new Date("01-01-2018"))}
                  maxDate={new Date(new Date())}
                  KeyboardButtonProps={{ 'aria-label': 'change date' }}
                />
              </WrapInputDate>
              <WrapInput style={{ position: 'relative', width: '7%' }}>
                <LabelInput>Mês</LabelInput>
                <MySelect
                  styles={multSelect}
                  placeholder="Opções.."
                  onChange={handleMesAno}
                  value={selectedMesAno}
                  isClearable={true}
                  isSearchable={true}
                  options={monthYear.map((item) => ({ value: item.id, label: item.monthYear }))}
                />
              </WrapInput>
              <WrapInput>
                <LabelInput>Equipe </LabelInput>
                <MultiSelect
                  overrideStrings={overrideStrings}
                  options={team}
                  value={teamSelected}
                  onChange={handleTeam}
                  labelledBy={"Select"}
                />
              </WrapInput>
              <WrapInput>
                <LabelInput>Colaboradores </LabelInput>
                <MultiSelect
                  overrideStrings={overrideStrings}
                  options={person}
                  value={personSelected}
                  onChange={handlePerson}
                  labelledBy={"Select"}
                />
              </WrapInput>
              <WrapInput style={{ width: '10%', marginTop: '10px' }}>
                <ItemsSearch>
                  <IconTxt
                    size={25}
                    title="Gerar AFD"
                    style={{ marginLeft: '0%', opacity: buttonDisable ? 0.5 : 1, pointerEvents: buttonDisable ? 'none' : 'auto' }}
                    onClick={() => !buttonDisable && gerarAfd()}
                  />
                  <Button className='widthButton' onClick={limparFiltros}>&nbsp;Limpar<DeleteOutlineIcon /></Button>
                </ItemsSearch>
              </WrapInput>
            </Wrap>
          </MuiPickersUtilsProvider>
        </form>

        {errosAfd.length > 0 && (
          <ErrorBox>
            <ErrorBoxTitle>
              Inconsistências encontradas — corrija na origem e gere novamente:
            </ErrorBoxTitle>
            <ErrorTable>
              <thead>
                <tr>
                  <th>Colaborador</th>
                  <th>CPF</th>
                  <th>Dia</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                {errosAfd.map((erro, idx) => (
                  <tr key={idx}>
                    <td>{erro.personName}</td>
                    <td>{erro.cpf}</td>
                    <td>{erro.dia}</td>
                    <td>{erro.motivo}</td>
                  </tr>
                ))}
              </tbody>
            </ErrorTable>
          </ErrorBox>
        )}
      </SearchBox>
      <Modal open={loadDialog} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
        {modalLoad}
      </Modal>
    </Container>
  )
}